import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Techsupport.css";
import Nav from "../Nav/Nav";

const Techsupport = () => {
  const location = useLocation();

  return (
    <>
      <Nav />
      <div className="container" style={{ marginTop: "10px" }}>
        <div className="row">
          <div className="col-md-8 installation-guide">
            
            <ol>
            <h2>Stepwise Guide to Install Eduroam</h2>
              <li>
                <strong>Generate strong passwords:</strong>
                <pre>{`RADIUS_SECRET=$(openssl rand -base64 12)
CLIENT_SECRET=$(openssl rand -base64 12)
MYSQL_ROOT_PASSWORD=$(openssl rand -base64 12)
RADIUS_DB_PASS=$(openssl rand -base64 12)`}</pre>
              </li>
              <li>
                <strong>Save generated passwords securely:</strong>
                <pre>{`echo "RADIUS_SECRET=$(openssl rand -base64 12)" > /root/freeradius_passwords.txt
chmod 600 /root/freeradius_passwords.txt`}</pre>
              </li>
              <li>
                <strong>Enter your institute's domain:</strong>
                <pre>{`echo "Enter the local realm i.e., Your institute domain (e.g., example.ac.in):"
read LOCAL_REALM`}</pre>
              </li>
              <li>
                <strong>Update system packages:</strong>
                <pre>{`apt update && apt upgrade -y`}</pre>
              </li>
              <li>
                <strong>Download FreeRADIUS:</strong>
                <pre>{`wget https://github.com/FreeRADIUS/freeradius-server/archive/v3.2.x.zip
unzip v3.2.x.zip
cd freeradius-server-3.2.x`}</pre>
              </li>
              <li>
                <strong>Build and install FreeRADIUS:</strong>
                <pre>{`./configure
make
sudo make install`}</pre>
              </li>
              <li>
                <strong>Set up FreeRADIUS as a service:</strong>
                <pre>{`systemctl daemon-reload
systemctl start freeradius
systemctl enable freeradius`}</pre>
              </li>
              <li>
                <strong>Configure MySQL for FreeRADIUS:</strong>
                <pre>{`mysql -u root -p"${`MYSQL_ROOT_PASSWORD`}" radius < /usr/local/etc/raddb/mods-config/sql/main/mysql/schema.sql
ln -sf /usr/local/etc/raddb/mods-available/sql /usr/local/etc/raddb/mods-enabled/
ln -sf /usr/local/etc/raddb/mods-available/eap /usr/local/etc/raddb/mods-enabled/`}</pre>
              </li>
              <li>
                <strong>Set permissions and backup configuration files:</strong>
                <pre>{`cp /usr/local/etc/raddb/mods-available/sql /usr/local/etc/raddb/mods-available/sql.bak
cp /usr/local/etc/raddb/mods-config/sql/main/mysql/queries.conf /usr/local/etc/raddb/mods-config/sql/main/mysql/queries.conf.bak
cp /usr/local/etc/raddb/mods-available/eap /usr/local/etc/raddb/mods-available/eap.bak`}</pre>
              </li>
              <li>
                <strong>Configure Certificate for FreeRADIUS:</strong>
                <pre>{`systemctl stop apache2
certbot certonly --standalone --agree-tos --email "${`CERTBOT_EMAIL`}" -d "${`LOCAL_REALM`}" --non-interactive
chown -R freerad:freerad /etc/letsencrypt/live/"${`LOCAL_REALM`}"
chmod -R 750 /etc/letsencrypt/live/"${`LOCAL_REALM`}"`}</pre>
              </li>
              <li>
                <strong>Restart and Test FreeRADIUS:</strong>
                <pre>{`systemctl restart freeradius
systemctl enable freeradius
radtest "test_user1" 12345678 localhost 0 testing123`}</pre>
              </li>
            </ol>
            <p>
              For detailed setup instructions, refer to the official documentation or
              contact support.
            </p>
          </div>
          <div className="col-md-4 tech-support">
            <h1 className="tech">Tech Support</h1>
            <p className="p"> How To Configure Device : - </p>

            <p className="links">
              1.
              <a
                href={require("../Document/IOS-Setup.pdf")}
                target="_blank"
                rel="noopener noreferrer"
              >
                IOS Configuration PDF
              </a>
            </p>
            <p className="links">
              2.
              <a
                href={require("../Document/Mac-OSX-Setup.pdf")}
                target="_blank"
                rel="noopener noreferrer"
              >
                Mac OSX Configuration
              </a>
            </p>
            <p className="links">
              3.
              <a
                href={require("../Document/Windows-7-OS-setup.pdf")}
                target="_blank"
                rel="noopener noreferrer"
              >
                Windows 7 Setup
              </a>
            </p>
          </div>
        </div>
      </div>
      <footer className="footer-1">
        <div className="footer-content-1">
          <p>&copy; Eduroam - ERNET India | 2024 All Rights Reserved</p>
        </div>
      </footer>
    </>
  );
};

export default Techsupport;